<div class="row page-header">
    <div class="col-12">
        <h1>Fab Shop Stock Products <small>HQ Materials filtered by category FAB.21</small></h1>
    </div>
</div>
<div [hidden]="isInitialLoading">
    <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs" style="margin-bottom: 10px">
        <li [ngbNavItem]="1" [destroyOnHide]="false">
            <a ngbNavLink>Products</a>
        </li>
        <li [ngbNavItem]="2" [destroyOnHide]="false">
            <a ngbNavLink>Types</a>
        </li>
    </ul>

    <div class="row" [hidden]="active !== 1">
        <div class="col-lg-12">
            <div class="row action-toolbar">
                <div class="col-12">
                    <form class="form-inline">
                        <action-toolbar-count [grid]="productsGrid"></action-toolbar-count>
                        <action-toolbar-search name="searchProducts" [(ngModel)]="productsGrid.filter"></action-toolbar-search>
                        <grid-export [grid]="productsGridEl" [name]="'FabShopStockProducts'"></grid-export>
                    </form>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <wj-flex-grid
                        id="productsGrid"
                        #productsGridEl
                        appAutoSize
                        (initialized)="onProductsGridInitialized(productsGridEl)"
                        (destroy)="productsGrid.destroy()"
                        [itemsSource]="productsGrid.view"
                        (beginningEdit)="cellBeginningEdit(productsGridEl, $event)"
                        (cellEditEnded)="cellEditEnded(productsGridEl, $event)"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column
                            [header]="'Material'"
                            [binding]="'material'"
                            [width]="180"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Description'"
                            [binding]="'description'"
                            [width]="'2*'"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Type'"
                            [binding]="'fabShopStockProductTypeId'"
                            [width]="'*'"
                            [dataMap]="typeMap"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Price'"
                            [binding]="'price'"
                            [format]="'C2'"
                            [width]="120"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                    </wj-flex-grid>
                </div>
            </div>
        </div>
    </div>

    <div class="row" [hidden]="active !== 2">
        <div class="col-lg-12">
            <div class="row action-toolbar">
                <div class="col-12">
                    <form class="form-inline">
                        <action-toolbar-count [grid]="typesGrid"></action-toolbar-count>
                        <action-toolbar-buttons
                            [grid]="typesGrid"
                            [canEdit]="canEdit"
                            [showAdd]="true"
                            [showEdit]="true"
                            [showDelete]="true"
                        ></action-toolbar-buttons>
                        <action-toolbar-search name="searchTypes" [(ngModel)]="typesGrid.filter"></action-toolbar-search>
                    </form>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <wj-flex-grid
                        id="typesGrid"
                        #typesGridEl
                        appAutoSize
                        (initialized)="typesGrid.initialize(typesGridEl)"
                        (destroy)="typesGrid.destroy()"
                        [itemsSource]="typesGrid.view"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column [header]="'Name'" [binding]="'name'" [width]="'*'" [isReadOnly]="true"></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Sort Order'"
                            [binding]="'sortOrder'"
                            [width]="120"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Archived'"
                            [binding]="'archived'"
                            [width]="110"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                    </wj-flex-grid>
                </div>
            </div>
        </div>
    </div>
</div>
